import User from 'models/user';
import IdListDTO from '../IdListDTO';

export class Widget74DTO {
  tenants: IdListDTO;

  results?: Widget74ResultDTO[];

  constructor() {
    this.tenants = new IdListDTO([]);
  }
}

export class Widget74ResultDTO {
  tenantId: string;

  lastLogin: string;

  monthlyActiveUsers: number;

  roleCount: { [role: number]: number };

  servicePrincipalCount: number;

  inactiveUserCount: number;

  inactiveOwners: User[];

  constructor() {
    this.tenantId = '';
    this.lastLogin = '';
    this.monthlyActiveUsers = 0;
    this.roleCount = {};
    this.inactiveUserCount = 0;
    this.servicePrincipalCount = 0;
    this.inactiveOwners = [];
  }
}
